import { FilterModalTypes } from '../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 1.8 },
  { title: 'Ativo', flex: 1.8 },
  { title: 'Data da cota' },
  { title: 'Valor da cota atual' },
  { title: 'Qtde. cotas' },
  { title: 'Valor bruto' },
  { title: 'Valor líquido' },
];

export const getClubsFilters = (
  dynamicFilters: FilterModalTypes.FilterType[]
): FilterModalTypes.FilterType[] => [
  {
    type: 'date',
    fieldName: 'positionDate',
    title: 'Data da posição',
    placeholder: 'Selecione a data da posição',
  },
  ...dynamicFilters,
  {
    type: 'range',
    fieldName: 'currentQuoteValue',
    labelType: 'number',
    title: 'Valor da cota atual',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'units',
    labelType: 'number',
    title: 'Quantidade de cotas',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'grossValue',
    labelType: 'number',
    title: 'Valor bruto',
    min: 0,
    max: 1000000000,
  },
  {
    type: 'range',
    fieldName: 'netValue',
    labelType: 'number',
    title: 'Valor líquido',
    min: 0,
    max: 1000000000,
  },
];
